import { StyledCard } from '@app/components/card/Card';
import { StyledButton } from '@app/components/button/Button';
import { useNavigate } from 'react-router';
import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { PageMeta } from '@app/components/meta/Meta';

export const SessionExpired = () => {
	const navigate = useNavigate();

	const redirectToLogin = () => {
		navigate('/');
	};

	return (
		<>
			<PageMeta title="Session Expired" />

			<StyledCard style={{ width: '100%', maxWidth: 680 }}>
				<h1 className="h2">Session Expired</h1>
				<p>Your session has timed out, please login again to continue.</p>

				<StyledButtonGroup>
					<StyledButton type="primary" color="blue" onClick={redirectToLogin}>
						Login
					</StyledButton>
				</StyledButtonGroup>
			</StyledCard>
		</>
	);
};

export default SessionExpired;
